import { HttpService } from ".";
import { HttpResponse } from "../../models/HttpResponse";
import { PrintConnectIndustry } from "../../models/Industry";
import {
  UserInfoResponse,
  UserStoreDetailInfoResponse,
  UserStoreInfoResponse,
  RegisterSilverMemberPayload,
  RegisterSilverMemberResponse,
  PrintConnectMemberSearch,
  UpdateUserStorePayload,
  UpdateUserStoreResponse,
  CustomerBdpNumberResponse
} from "../../models/User";

const baseUrl_PrintProductApps_Service = process.env.REACT_APP_API_PRINTPRODUCTAPPS_SERVICE;

export const getUserInfo = async () => {
  return HttpService.request<UserInfoResponse>(
    "GET",
    `${baseUrl_PrintProductApps_Service}/PrintProductApps/CaPPPrintProducts/GetUserInfo`
  );
};

export const getUserToken = async () => {
  try {
    const response = await HttpService.request<string>(
      "GET",
      `${baseUrl_PrintProductApps_Service}/PrintProductApps/CaPPPrintProducts/GetUserToken`
    );
    return response;
  } catch (error) {
    console.error("Error fetching user token:", error);
    window.open("/Account/AccountLogin.aspx?r=/pages/print-connect-registration-form", "_self");
  }
};

export const getUserStoreInfo = async (): Promise<UserStoreInfoResponse | null> => {
  const response: HttpResponse<UserStoreInfoResponse> = await HttpService.request<UserStoreInfoResponse>(
    "GET",
    `${baseUrl_PrintProductApps_Service}/PrintProductApps/CaPPUser/GetUserStoreInfo`
  );
  const responseData = response.data;
  if (!responseData) return null;

  const userInfoResponse: UserStoreInfoResponse = responseData;
  userInfoResponse.StoreId = userInfoResponse.StoreId || 'S330';
  return userInfoResponse;
};

export const getCustomerBdpNumber = async (): Promise<
  HttpResponse<CustomerBdpNumberResponse | string>
> => {
  return HttpService.request<CustomerBdpNumberResponse | string>(
    "GET",
    `${baseUrl_PrintProductApps_Service}/PrintProductApps/CaPPUser/GetCustomerBdpNumber`
  );
};


export const resolveCustomerBdpNumber = (
  response: HttpResponse<CustomerBdpNumberResponse | string> | null | undefined,
): string => {
  const data = response?.data;
  if (data == null) {
    return "";
  }
  if (typeof data === "string") {
    const trimmed = data.trim();
    if (!trimmed || trimmed.toLowerCase().startsWith("failed")) {
      return "";
    }
    return trimmed;
  }
  return (data.BdpNumber ?? "").trim();
};

export type GoldMembershipOptionSet = {
  SKU: string;
};

export const getGoldMembershipOptionSet = async (): Promise<GoldMembershipOptionSet | null> => {
  const search = new URLSearchParams({
    subProductName: "Ops_EPrint_Gold_Setup",
    size: "",
    isOnlyOnePackSize: "false",
  });

  const response = await HttpService.request<GoldMembershipOptionSet>(
    "GET",
    `${baseUrl_PrintProductApps_Service}/PrintProductApps/CaPPPrintProducts/GetGoldMembershipOptionSet?${search.toString()}`
  );

  const payload = response.data;
  if (!payload?.SKU) return null;
  return { SKU: payload.SKU };
};

export const getPrintConnectIndustriesList = async () => {
  return HttpService.request<PrintConnectIndustry[]>(
    "GET",
    `${baseUrl_PrintProductApps_Service}/PrintProductApps/CaPPPrintProducts/GetPrintConnectIndustriesList`
  );
};

export const getUserStoreDetailInfo = async (): Promise<UserStoreDetailInfoResponse | null> => {
  const response: HttpResponse<UserStoreDetailInfoResponse> = await HttpService.request<UserStoreDetailInfoResponse>(
    "GET",
    `${baseUrl_PrintProductApps_Service}/PrintProductApps/CaPPUser/GetUserStoreDetailInfo`
  );

  const responseData = response.data;
  if (!responseData) return null;

  return responseData;
};

export const getKioskStoreInfo = async (): Promise<UserStoreDetailInfoResponse | null> => {
  const response: HttpResponse<UserStoreDetailInfoResponse> = await HttpService.request<UserStoreDetailInfoResponse>(
    "GET",
    `${baseUrl_PrintProductApps_Service}/PrintProductApps/CaPPUser/GetKioskStoreInfo`
  );

  const responseData = response.data;
  if (!responseData) return null;

  return responseData;
};

export const searchMemberInfoByUserId = async (userId: number) => {
  return HttpService.request<PrintConnectMemberSearch>(
    "GET",
    `${baseUrl_PrintProductApps_Service}/PrintProductApps/CaPPUser/SearchPrintconnectMemberInfoByUserId?userId=${userId}`
  );
};

export const registerSilverMember = async (payload: RegisterSilverMemberPayload) => {
  return HttpService.request<RegisterSilverMemberResponse>(
    "POST",
    `${baseUrl_PrintProductApps_Service}/PrintProductApps/CaPPUser/CreateNewPrintConnectMember`,
    payload,
  );
};
export const UpdateUserStore = async (payload: UpdateUserStorePayload) => {
  return HttpService.request<UpdateUserStoreResponse>(
    "POST",
    `${baseUrl_PrintProductApps_Service}/PrintProductApps/CaPPUser/UpdateUserStore`,
    payload,
    { "X-Feature-feature_flag_preferred_store_enabled": "true" }
  );
};